import { render } from "./Auction_creation.vue?vue&type=template&id=a4a99eae"
import script from "./Auction_creation.vue?vue&type=script&lang=js"
export * from "./Auction_creation.vue?vue&type=script&lang=js"
script.render = render

export default script